export function filterAuthorizedRoutes(routes, authorizedRoutes){
    // 递归函数用于过滤有权限的路由及其子路由
    // function filterAuthorizedRoutes(routes, authorizedRoutes) {
    const result = [];
    for (const route of routes) {
        // console.log(route,routes)
        // const match = authorizedRoutes.includes(route.id); // 检查当前路由是否有权限
        const match = authorizedRoutes.includes(route.meta && route.meta.title); // 检查当前路由是否有权限
        if (match) {
            result.push(route); // 如果当前路由有权限，将其添加到结果数组中
            if (route.children) {
                const children = filterAuthorizedRoutes(route.children, authorizedRoutes); // 递归处理子路由
                if (children.length > 0) {
                    route.children = children; // 将有权限的子路由添加到当前路由的 children 数组中
                }
            }
        }
    }
    return result;
}